import React, { FC } from 'react'
import './ModularPublicCard.scss'

interface IModularPublicCardProps {
  title: string
  image: string
}

const ModularPublicCard: FC<IModularPublicCardProps> = ({
  title,
  image
}) => {
  return (
    <div className='modular-public-card--container'>
      <div className='modular-public-card--firs-card'>
        <img
          src={image}
          alt="icon"
        />
        <p>{title}</p>
      </div>
    </div>
  )
}

export default ModularPublicCard
